import { Action } from '@ngrx/store';
import { Information } from '../../../models/information.model';
import { InformationStructure } from 'app/models/information-structure.model';
import { InformationGroup, BannerMessage } from '@model';

export enum InformationActionTypes {
  LoadBanners = '[Information banners] Load',
  LoadBannersSuccess = '[Information banners] Load success',
  LoadBannersFail = '[Information banners] Load fail',

  AddStartPageBanner = "[Information banners] Add StartPage Banner",
  AddPreClosureBanner = '[Information banners] Add PreClosure Banner',
  DismissPreClosureBanner = '[Information banners] Dismiss PreClosure Banner',
  DismissBanner = '[Information banners] Dismiss',
  ShowBanners = '[Information banners] Show all',

  LoadData = '[Information] Load',
  LoadDataSuccess = '[Information] Load success',
  LoadDataFail = '[Information] Load fail',

  UpdateItem = '[Information] Update',
  UpdateGroup = '[InformationGroup] Update'
}

export class LoadBanners implements Action {
  readonly type = InformationActionTypes.LoadBanners;
  constructor() {}
}

export class LoadBannersSuccess implements Action {
  readonly type = InformationActionTypes.LoadBannersSuccess;
  constructor(public payload: BannerMessage[]) {}
}

export class LoadBannersFail implements Action {
  readonly type = InformationActionTypes.LoadBannersFail;
  constructor(public payload: any) {}
}

export class AddStartPageBanner implements Action{
  readonly type = InformationActionTypes.AddStartPageBanner;
  constructor(public payload: BannerMessage){}
}

export class AddPreClosureBanner implements Action{
  readonly type = InformationActionTypes.AddPreClosureBanner;
  constructor(public payload: BannerMessage){}
}

export class DismissPreClosureBanner implements Action{
  readonly type = InformationActionTypes.DismissPreClosureBanner;
  constructor(){}
}

export class DismissBanner implements Action{
  readonly type = InformationActionTypes.DismissBanner;
  constructor(public payload: number){}
}

export class ShowBanners implements Action{
  readonly type = InformationActionTypes.ShowBanners;
  constructor(){}
}

export class Load implements Action {
  readonly type = InformationActionTypes.LoadData;
  constructor() {}
}

export class LoadSuccess implements Action {
  readonly type = InformationActionTypes.LoadDataSuccess;
  constructor(public payload: InformationStructure) {}
}

export class LoadFail implements Action {
  readonly type = InformationActionTypes.LoadDataFail;
  constructor(public payload: any) {}
}

export class Update implements Action {
  readonly type = InformationActionTypes.UpdateItem;
  constructor(public payload: Information) {}
}

export class UpdateGroup implements Action {
  readonly type = InformationActionTypes.UpdateGroup;
  constructor(public payload: InformationGroup) {}
}

export type InformationActions =
  | Load
  | LoadSuccess
  | LoadFail
  | LoadBanners
  | LoadBannersSuccess
  | LoadBannersFail
  | AddStartPageBanner
  | AddPreClosureBanner
  | DismissPreClosureBanner
  | DismissBanner
  | ShowBanners
  | Update
  | UpdateGroup;
